module.exports = __webpack_public_path__ + "static/media/Circo2025_12.29c99c72.webp";